// bootstrap frontend
require('./bootstrap');

// components
require('./components/nav-fixed');
require('./components/mask');
require('./components/menu-sidebar');
require('./components/carousel');
require('./components/notification');
require('./components/tooltip');
require('./components/flags');
require('./components/favorites');
require('./components/scrolled');
require('./components/laravel');
